import { render } from "./index4.vue?vue&type=template&id=8326fb2e&scoped=true"
import script from "./index4.vue?vue&type=script&lang=js"
export * from "./index4.vue?vue&type=script&lang=js"

import "./index4.vue?vue&type=style&index=0&id=8326fb2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8326fb2e"]])

export default __exports__